/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import product from "../../../../models/product";
// CSS
import "../../../../css/SelectOptionBtn.css";

let $ = window.$;
class Lv3SelectOptionBtn extends React.Component {
  state = {
    myCbu: {},
    isSoldOut: false,
    productCbu: "",
    myStockQuantity: "",
    isOutOfStock: false
  };
  componentDidUpdate() {
    const {
      stockQuantity,
      earmarkQuantity,
      cartItems,
      product,
      cbu
    } = this.props;
    function outOfStock(stockQuantity, earmarkQuantity, purchase) {
      return stockQuantity - earmarkQuantity - purchase <= 0;
    }
    function howManyMineInMiniCart(cartItems, myCbu) {
      let count = 0;

      cartItems &&
        cartItems.forEach(function(item) {
          if (item.cbu === myCbu) {
            count++;
          }
        });
      return count;
    }

    if (product.cbu === cbu) {
      //算出我在miniCart 有幾筆?
      const purchase = howManyMineInMiniCart(cartItems, cbu);
      //是否我outOfStock
      let isOutOfStock = outOfStock(stockQuantity, earmarkQuantity, purchase);

      this.setState((prevState, props) => {
        if (prevState.isOutOfStock !== isOutOfStock) {
          return {
            ...this.state,
            isOutOfStock: isOutOfStock
          };
        }
      });
    }
  }
  getClass(defaultValue, itemCode) {
    //如果賣完，選項也要變灰色
    if (this.state.isOutOfStock) {
      return "notAvailable blockBtn border-grey smaller";
    }
    if (itemCode === defaultValue) {
      return "select blockBtn border-grey smaller";
    }
    return "blockBtn border-grey smaller";
  }
  handleClick = e => {
    const { code, selectLv3Option, changeLv3SelectOptionDefault } = this.props;

    $(".outOfStockForm_wrap")
      .finish()
      .fadeOut();

    selectLv3Option(code);
    changeLv3SelectOptionDefault(code);
  };
  render() {
    const { code, lv3Default, name } = this.props;

    return (
      <a
        className={this.getClass(lv3Default, code)}
        onClick={e => this.handleClick(e)}
      >
        <span>{name}</span>
      </a>
    );
  }
}
const mapStateToProps = state => {
  return {
    lv3Default: state.product.lv3Default,
    stockQuantity: state.product.productBookingUnit.quantity,
    earmarkQuantity: state.product.productBookingUnit.earmarkQuantity,
    cartItems: state.cart.cartItems,
    product: state.product.productBookingUnit
  };
};

const mapDispatchToProps = () => {
  return {
    selectLv3Option: code => product.actions.selectLv3Option(code),
    changeLv3SelectOptionDefault: data =>
      product.actions.changeLv3SelectOptionDefault(data)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Lv3SelectOptionBtn);
